import { useEffect, useState } from 'react';
import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { reloadForUpdate, startAppVersionWatch } from '../pwa/versionCheck';

export function AppUpdateBanner() {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const [isUpdating, setIsUpdating] = useState(false);

  useEffect(() => {
    return startAppVersionWatch(() => setVisible(true));
  }, []);

  const handleUpdate = () => {
    if (isUpdating) return;
    setIsUpdating(true);
    reloadForUpdate();
  };

  if (!visible) {
    return null;
  }

  return (
    <div
      className="fixed inset-x-4 bottom-[max(5.5rem,calc(env(safe-area-inset-bottom)+4.5rem))] md:bottom-6 z-[60] flex items-center gap-3 rounded-2xl bg-white/95 px-4 py-3 shadow-float backdrop-blur-xl"
      role="alertdialog"
      aria-live="polite"
      aria-label={t('Доступна новая версия приложения')}
    >
      <RefreshCw size={18} className="shrink-0 text-primary" aria-hidden />
      <p className="flex-1 text-sm font-semibold text-slate-800">
        {t('Доступна новая версия приложения')}
      </p>
      <button
        type="button"
        className="btn-primary shrink-0 text-sm py-2 px-4 disabled:opacity-60"
        onClick={handleUpdate}
        disabled={isUpdating}
      >
        {isUpdating ? t('Обновление...') : t('Обновить')}
      </button>
    </div>
  );
}
